/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VivaLiteScanStrictHttpResponse } from '../../viva-lite-scan-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TokenRequestModel } from '../../models/token-request-model';
import { TokenResponseModel } from '../../models/token-response-model';

export interface SessionAccessTokenPost$Params {
      body?: TokenRequestModel
}

export function sessionAccessTokenPost(http: HttpClient, rootUrl: string, params?: SessionAccessTokenPost$Params, context?: HttpContext): Observable<VivaLiteScanStrictHttpResponse<TokenResponseModel>> {
  const rb = new RequestBuilder(rootUrl, sessionAccessTokenPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VivaLiteScanStrictHttpResponse<TokenResponseModel>;
    })
  );
}

sessionAccessTokenPost.PATH = '/Session/AccessToken';
